export interface PaymentProfileError {
  message: string;
}

export interface PaymentProfile {
  eephemeralUuid: string | null;
  encodedAffiliateCustomerId: string | null;
  encodedPaymentProfileId: string;
  errors: PaymentProfileError[];
  status: PaymentProfileResponseStatus;
  token?: string;
  authenticationProvider?: string;
  paymentProvider?: string;
}

export enum PaymentProfileResponseStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Error = 'ERROR',
  THREEDS_V2_CHALLENGED = 'THREEDS_CHALLENGED',
  THREEDS_V1_CHALLENGED = 'THREEDS_V1_CHALLENGED',
}

export enum PaymentMode {
  ECommerce = 'ECOMMERCE', // often has the name tokenless in legacy code
  Tokenize = 'TOKENIZE',
  Tokenize_3ds_v2 = 'TOKENIZE_3DS_V2',
}

export interface EcommerceTransactionReference {
  transactionStatus: PaymentProfileResponseStatus;
  eephemeralUuid: string;
  encodedPaymentProfileId: string;
}

export interface PaymentProfileResult {
  encryptedSessionId: string | null;
  paymentProfile: PaymentProfile | null;
  isSuccess: boolean;
  isRejected: boolean;
  mode: PaymentMode;
  transactionReferences?: Record<string, EcommerceTransactionReference>; // for 3ds with ecommerce
  encodedAffiliateCustomerId?: string | null;
}
